import * as React from 'react';
import { useState, useEffect } from "react";
import ProductListingAPICall from "../../../service/ProductListingAPICall";
import { useForm } from 'react-hook-form';
import Modal from "../Modal";
import System from 'src/helper/system';
import { useAxiosIndicatorCheck } from "../../../store/hook/useAxiosIndicatorCheck";
import { useDOMAttachToSystemStore } from 'src/hooks/domAttachToSystem';

const SendEmailOfCurrentPage = () => {
    const [__check] = useAxiosIndicatorCheck();
    const [sendToEmail, setSendToEmail] = useState([{}])
    const [totalSendToEmail, setTotalSendToEmail] = useState(0)
    const [status, SetStatus] = useState(false);
    const [sendMailUrl, SetSendMailUrl] = useState(window.location.href);
    const [{ SendEmailOfCurrentPage, latest_system_notification_UUID, latest_system_notification_name }, {}, {}] = useDOMAttachToSystemStore();    
    useEffect(() => {
        if (latest_system_notification_name === 'SendEmailOfCurrentPage') {
            if (SendEmailOfCurrentPage.data !== undefined && SendEmailOfCurrentPage.data.send_mail_url !== undefined) {
                SetSendMailUrl(SendEmailOfCurrentPage.data.send_mail_url)
            }
            setSendToEmail([{}])
            setTotalSendToEmail(0)
            SetStatus(true)
        } else {
            SetStatus(false)
        }
    }, [latest_system_notification_UUID]);


    const onHide = (action = true) => {
        SetStatus(false)
    };


    const emailPattern = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

    const handleChange = (i, e) => {
        let newSendToEmail = [...sendToEmail];
        newSendToEmail[i] = e.target.value;
        setSendToEmail(newSendToEmail);
    }

    const addFormFields = () => {
        setSendToEmail([...sendToEmail, {}])
    }

    const removeFormFields = (i) => {
        let newSendToEmail = [...sendToEmail];
        newSendToEmail.splice(i, 1);
        setSendToEmail(newSendToEmail)
    }

    useEffect(() => {
        setTotalSendToEmail(sendToEmail.length)
    }, [sendToEmail])

    const { register, handleSubmit, formState: { errors } } = useForm();

    const onSubmit = async (data) => {
        let reqBody = {
            "link": sendMailUrl,
            "sender": data.sender,
            "sendTo": sendToEmail,
            "subject": data.subject,
            "message": data.message
        }
        let res = {}
        await new ProductListingAPICall().sendCurrentPageEmail(reqBody).then(function (response) {
            res = response.data;
            System.popup('ThankYouPopup', {});
        });
    }

    return (
        <>
            <Modal show={status} onHide={() => {
                onHide()
            }}>
                <div className="avnet-modal modal-630">
                    <div className="avnet-modal-inner">
                        {/* Modal Header */}
                        <button type="button" className="close" data-dismiss="modal"
                            onClick={() => {
                                onHide()
                            }}>×
                        </button>
                        <div className="modal-header justify-content-center">
                            <h2 className="pcn-modal-heading m-t-20 mb-0">Send as link to this page</h2>
                        </div>
                        {/* Modal body */}
                        <div className="modal-body">
                            <form id="hook-form">
                                <div className="summary mb-2"><strong className="block">Link</strong>
                                    <div id="linkToSend">
                                        {sendMailUrl}
                                    </div>
                                </div>
                                <div className="row m-0">
                                    <div className="col-12">
                                        <div className="form-group">
                                            <label htmlFor="email">Sender </label>
                                            <input type="text" name="sender" aria-label="Share via email"
                                                id="share_input_mailFrom" size={60}
                                                className="form-control"
                                                placeholder="email@address.com"
                                                defaultValue={System.auth('email')}
                                                {...register("sender", { required: false, pattern: emailPattern })} />
                                            <p className="error">{errors.sender?.type === 'pattern' && "Please enter a valid Email id"}</p>
                                        </div>

                                        {sendToEmail.map((element, index) => (
                                            <div className="form-group" key={index}>
                                                <label htmlFor="email">Send To <span
                                                    className="mandatory">*</span></label>
                                                <div className="d-flex">
                                                    <input type="text" name={"sendto-" + index}
                                                        aria-label="Share via email"
                                                        id={"share_input_mailTo-" + index} size={60}
                                                        className="form-control"
                                                        placeholder="email@address.com" key={index}
                                                        {...register("sendto-" + index, {
                                                            required: true,
                                                            pattern: emailPattern
                                                        })}
                                                        onChange={(e) => {
                                                            handleChange(index, e)
                                                        }}
                                                    />
                                                    {
                                                        index ?
                                                            <button type="button"
                                                                className="remove-email btn-link text-black"><span
                                                                    className="fa fa-times"
                                                                    onClick={() => removeFormFields(index)} /><span
                                                                        className="sr-only">Remove Email</span></button>
                                                            : null
                                                    }
                                                </div>
                                                <p className="error">{errors && errors['sendto' + '-' + index] && errors["sendto" + '-' + index].type === 'required' && "Please enter a valid Email id"}</p>
                                                <p className="error">{errors && errors['sendto' + '-' + index] && errors["sendto" + '-' + index].type === 'pattern' && "Please enter a valid Email id"}</p>
                                            </div>
                                        ))}
                                        {
                                            totalSendToEmail <= 2 ?
                                                <a className="add-more AddAnotherAddressDivOne mb-1 text-blue2 d-block"
                                                    onClick={() => addFormFields()}>+ Add another address</a>
                                                : null
                                        }
                                    </div>
                                    <div className="col-12">
                                        <div className="form-group">
                                            <label htmlFor="email">Subject</label>
                                            <input type="text" name="subject" size={60}
                                                className="form-control" id="share_input_subject"
                                                placeholder="Category" data-di-id="#share_input_subject"
                                                {...register("subject", { required: false, maxLength: 99 })} />
                                            <p className="error">{errors.subject?.type === 'maxLength' && "Please enter a valid Subject, Max character exceeded"}</p>
                                        </div>
                                    </div>
                                    <div className="col-12">
                                        <div className="form-group">
                                            <label htmlFor="email">Message</label>
                                            <textarea name="message" rows={8} cols={60}
                                                className="avnet-textBox form-control h-auto"
                                                placeholder="I'd like to share this page with you."
                                                id="share_input_body"
                                                {...register("message", { required: false, maxLength: 999 })} />
                                            <p className="error">{errors.message?.type === 'maxLength' && "Please enter a valid Message, Max character exceeded"}</p>
                                        </div>
                                    </div>
                                </div>
                            </form>
                        </div>
                        {/* Modal footer */}
                        {__check(['SEND_CONTACT_US_EMAIL_API_CALL']).render}
                        {!__check(['SEND_CONTACT_US_EMAIL_API_CALL']).status &&
                            <div className="modal-footer text-center">
                                <div className="modal-footer-actions">
                                    <button type="button" className="bs5 btn btn-secondary minw-auto"
                                        data-bs-toggle="modal" data-bs-target="#myModal"
                                        onClick={() => {
                                            onHide()
                                        }}>
                                        Close
                                    </button>
                                    <button type="submit" className="bs5 btn btn-primary minw-auto"
                                        form="hook-form" data-bs-toggle="modal"
                                        data-bs-target="#myModal" onClick={handleSubmit(onSubmit)}>
                                        Send
                                    </button>
                                </div>
                            </div>
                        }
                    </div>
                </div>
            </Modal>
        </>
    );
}

export default SendEmailOfCurrentPage;